export const getScrollbarSize = (): number => {
  const documentWidth = document.documentElement.clientWidth
  return Math.abs(window.innerWidth - documentWidth)
}

export const getBodyPadding = (): number => {
  const paddingDirection = document?.dir === 'rtl' ? 'paddingLeft' : 'paddingRight'
  return parseInt(window.getComputedStyle(document.body)[paddingDirection], 10) || 0
}
